define([], () => ({
  RESIZE_MODAL: 'RESIZE_MODAL',
  UPDATE_APP_STATE: 'UPDATE_APP_STATE',

  REQUEST_SETTINGS: 'REQUEST_SETTINGS',
  RECEIVE_SETTINGS: 'RECEIVE_SETTINGS',
  ERROR_SETTINGS: 'ERROR_SETTINGS',
  UPDATE_SUBSCRIBERS_SETTINGS: 'UPDATE_SUBSCRIBERS_SETTINGS',
  UPDATE_SUBSCRIBERS_SETTING: 'UPDATE_SUBSCRIBERS_SETTING',

  ACCEPT_TOS: 'ACCEPT_TOS',

  REQUEST_SUBSCRIBER: 'REQUEST_SUBSCRIBER',
  RECEIVE_SUBSCRIBER: 'RECEIVE_SUBSCRIBER',
  ERROR_SUBSCRIBER: 'ERROR_SUBSCRIBER',

  REQUEST_SUBSCRIBERS: 'REQUEST_SUBSCRIBERS',
  RECEIVE_SUBSCRIBERS: 'RECEIVE_SUBSCRIBERS',
  ERROR_SUBSCRIBERS: 'ERROR_SUBSCRIBERS',
  DELETE_SUBSCRIBERS: 'DELETE_SUBSCRIBERS',
  UPDATE_SUBSCRIBERS_FILTER: 'UPDATE_SUBSCRIBERS_FILTER',
  RECEIVE_DOWNLOAD_PROGRESS: 'RECEIVE_DOWNLOAD_PROGRESS',

  REQUEST_SUBSCRIBER_LISTS: 'REQUEST_SUBSCRIBER_LISTS',
  RECEIVE_ALL_SUBSCRIBER_LISTS: 'RECEIVE_ALL_SUBSCRIBER_LISTS',
  RECEIVE_SUBSCRIBER_LISTS: 'RECEIVE_SUBSCRIBER_LISTS',
  REQUEST_SUBSCRIBER_LIST: 'REQUEST_SUBSCRIBER_LIST',
  RECEIVE_SUBSCRIBER_LIST: 'RECEIVE_SUBSCRIBER_LIST',
  REQUEST_UPDATE_SUBSCRIBER_LIST: 'REQUEST_UPDATE_SUBSCRIBER_LIST',
  ERROR_SUBSCRIBER_LISTS: 'ERROR_SUBSCRIBER_LISTS',
  DELETE_SUBSCRIBER_LISTS: 'DELETE_SUBSCRIBER_LISTS',

  REQUEST_SUBSCRIBER_LIST_CONTACTS: 'REQUEST_SUBSCRIBER_LIST_CONTACTS',
  RECEIVE_SUBSCRIBER_LIST_CONTACTS: 'RECEIVE_SUBSCRIBER_LIST_CONTACTS',

  REQUEST_CAMPAIGN: 'REQUEST_CAMPAIGN',
  RECEIVE_CAMPAIGN: 'RECEIVE_CAMPAIGN',
  ERROR_CAMPAIGN: 'ERROR_CAMPAIGN',
  CREATE_CAMPAIGN: 'SEND_CAMPAIGN',

  RESET_CAMPAIGN_ERRORS: 'RESET_CAMPAIGN_ERRORS',

  // A universal action called on all requests.
  VALIDATE: 'VALIDATE',

  START_IMPORTING: 'START_IMPORTING',
  ERROR_IMPORT: 'ERROR_IMPORT',
  RECEIVE_IMPORT: 'RECEIVE_IMPORT',
  ERROR_IMPORT_CANCELLATION: 'ERROR_IMPORT_CANCELLATION',
  IMPORT_CANCELLATION: 'IMPORT_CANCELLATION',
  DISMISS_IMPORT: 'DISMISS_IMPORT',
  IMPORT_MAPPED: 'IMPORT_MAPPED',
  FETCH_IMPORTS: 'FETCH_IMPORTS',
  RECEIVE_IMPORTS: 'RECEIVE_IMPORTS',
  MAP_IMPORT: 'MAP_IMPORT',
  REMAP_IMPORT: 'REMAP_IMPORT',

  REQUEST_SHOPIFY_SYNC: 'REQUEST_SHOPIFY_SYNC',
  RECEIVE_SHOPIFY_SYNC: 'RECEIVE_SHOPIFY_SYNC',
}));
